import { render, staticRenderFns } from "./AgeRangeStatisticsChart.vue?vue&type=template&id=523548dc&scoped=true"
import script from "./AgeRangeStatisticsChart.vue?vue&type=script&lang=js"
export * from "./AgeRangeStatisticsChart.vue?vue&type=script&lang=js"
import style0 from "./AgeRangeStatisticsChart.vue?vue&type=style&index=0&id=523548dc&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "523548dc",
  null
  
)

export default component.exports